import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../../store/modalSlice";

import { cancellationTableColumnsConfig } from "./cancellationTableColumnsConfig";
import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
const statusMap = {
  Approve: 13,
  Reject: 20,
};

export const CancellationTablePage = ({ data }) => {
  const [columnDefs, setColumnDefs] = useState([]);
  const dispatch = useDispatch();
  const navigate =useNavigate();

  const handleOpenModal = useCallback(
    (rowData, identifier) => {
      console.log("identifier:", identifier); // Optional debug

      dispatch(
        openModal({
          component: "DynamicForm",
          uiData: {
            heading:`${identifier} Request`,
            primaryButtonLabel: identifier,
            isGridRequired: true,
            
          },
          configData: {
            ...rowData,
            order_status: statusMap[identifier],
          },
          operationType: identifier,
          module: "cancellation",
        })
      );
    },
    [dispatch]
  );

  const handleCancellationDetail = useCallback(
      (cancelltionId) => {
        // dispatch(setOrderId({ order_id: rowId }));
        console.log("details", cancelltionId);
        navigate(`${cancelltionId}`);
      },
      [navigate]
    );

  useEffect(() => {
    setColumnDefs(
      cancellationTableColumnsConfig["cancellation"](handleOpenModal,handleCancellationDetail)
    );
  }, [handleCancellationDetail, handleOpenModal]);

  return <Table data={data} columns={columnDefs} />;
};
